<template>
  <div class="message">
    <div class="title">
      <img src="../assets/images/message/banner.png" />
      <h2>祝福集</h2>
    </div>
    <div class="collect">
      <!-- 单个祝福 -->
      <template v-for="item in userInfo" :key="item.id">
        <div class="info">
          <img src="../assets/images/message/back.png" />
          <div class="word">
            <p>{{ item.blessing }}</p>
            <h3>{{ item.uname }}</h3>
            <h4>{{ item.time }}</h4>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { userInfo } from '../data'

export default {
  setup() {
    return {
      userInfo
    }
  }
}
</script>

<style scoped>
.message {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  transition: all 0.5s ease-in-out;
}

.message .title {
  position: relative;
  padding: 10px 0;

  display: flex;
  justify-content: center;
}

.message .title img {
  width: 80%;
  height: auto;

  opacity: 0;

  animation: show 0.8s ease-in forwards;
}

.message .title h2 {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-family: mading;
  font-size: 55px;
  color: #fff;

  text-align: center;
  text-shadow: 3px 3px 3px #5635ff;

  opacity: 0;

  animation: showH2 0.8s ease-in forwards;
}

.message .collect {
  width: 90%;
  margin-bottom: 20px;
  /* display: flex; */
  /* 换行 */
  /* flex-wrap: wrap; */
  /* 贴边显示 */
  /* justify-content: space-between; */

  /* 控制屏幕分为多少列 */
  column-count: 4;
  /* 控制列与列之间的距离 */
  column-gap: 5px;

  opacity: 0;

  animation: translateY 1s ease-in forwards;
}

.collect .info,
.collect .info img,
.collect .info .word,
.collect .info .word p,
.collect .info .word h3,
.collect .info .word h4 {
  /* Chrome, Safari, Opera */
  page-break-inside: avoid;
  /* Firefox */
  break-inside: avoid;
  /* IE 10+ */
  break-inside: avoid-column;
}

.collect .info {
  /* width: calc(100%/5 - 20px);
    height: 130px; */
  background-color: #fff;
  /* border: 3px solid #000; */
  border-radius: 10px;
  /* box-shadow: 3px 3px 3px #5635ff; */

  margin: 0 5px 10px;

  font-family: mading;

  overflow: hidden;

  position: relative;
}

.collect .info img {
  position: absolute;
  bottom: 10px;
  left: 10px;
  /* transform: translate(-50%,-50%); */

  width: 20%;
  height: auto;
}

.collect .info .word {
  display: flex;
  flex-direction: column;

  padding: 10px;
}

.collect .word p {
  /* 换行 */
  word-wrap: break-word;
  border-bottom: 2px dashed #150a29;

  font-size: 20px;
}

.collect .word h3 {
  padding: 10px 0;
  text-align: right;

  font-size: 18px;
}

.collect .word h4 {
  font-family: hole;
  text-align: right;

  font-size: 15px;
}

@keyframes show {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes showH2 {
  0% {
    opacity: 0;
    transform: translate(0, 0);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes translateY {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式 */
/* 超小屏幕(手机，<768px) */
@media screen and (max-width: 767px) {
  .collect .word p {
    font-size: 14px;
  }
  .collect .word h3 {
    font-size: 12px;
  }
  .collect .word h4 {
    font-size: 10px;
  }

  .message .collect {
    /* 控制屏幕分为多少列 */
    column-count: 2;
  }
  .collect .info img {
    width: 25%;
  }
  .message .title h2 {
    font-size: 25px;
  }
}
</style>
